import { FunctionComponent } from "react";
import MuiCheckbox from "@mui/material/Checkbox";
import { CheckboxProps } from "./ICheckbox";

const CommonCheckbox: FunctionComponent<CheckboxProps> = (props) => {
    const {
        id,
        disabled,
        checked,
        defaultChecked,
        color,
        icon,
        checkedIcon,
        disableRipple,
        onChange,
        required,
        size,
        sx,
        checkboxCalssName,
        indeterminate,
        indeterminateIcon,
    } = props;

    return (
        <MuiCheckbox
            id={id}
            disabled={disabled}
            checked={checked}
            defaultChecked={defaultChecked}
            color={color}
            icon={icon}
            checkedIcon={checkedIcon}
            disableRipple={disableRipple}
            onChange={onChange}
            required={required}
            size={size}
            sx={sx}
            className={`checkbox ${checkboxCalssName}`}
            indeterminate={indeterminate}
            indeterminateIcon={indeterminateIcon}
        />
    );
};

export default CommonCheckbox;
